<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuFlag"
    :nudge-right="0"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <div
      slot="activator"
      class="color-picker-value circle"
      :style="{
        'background-color': value
      }"
    ></div>
    <div class="color-picker-container">
      <Sketch :value="value" @input="onInputChange"/>
      <v-layout row wrap justify-space-between pa-2>
        <button class="dt-button v1 s6" @click="onOKClick">
          Ok
        </button>
        <button class="dt-button s6" @click="onCancelClick">
          Cancel
        </button>
      </v-layout>
    </div>
  </v-menu>
</template>

<script>
import { Sketch } from "vue-color";

export default {
  components: {
    Sketch
  },
  props: {
    placeholder: {
      type: String,
      default: () => "Date"
    },
    value: {
      required: false
    },
    required: {
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function(to, from) {}
    }
  },
  data: function() {
    return {
      menuFlag: false,
      changedValue: null,
    };
  },
  methods: {
    onInputChange: function(value) {
      this.changedValue = value;
    },
    onOKClick: function() {
      this.menuFlag = false;
      this.$emit('input', this.changedValue);
    },
    onCancelClick: function() {
      this.menuFlag = false;
    }
    //MARK: Methods
  }
};
</script>

<style lang="scss">
// Global Date Picker Style
.color-picker-value {
  cursor: pointer;
  width: 15px;
  height: 15px;
}
.color-picker-container{
  position: relative;
  width: 100%;
  background: white;
  .vc-sketch {
    width: 290px;
    box-shadow: none;
  }
}
</style>
